import {EPreviewTextVariantKey} from "../interfaces/preview-text-variant.interface";
import {PreviewTextService} from "../preview-text.service";

export function _pt(key: EPreviewTextVariantKey | string) {
    return PreviewTextService.getPreviewText(key as EPreviewTextVariantKey);
}
